import { FunctionComponent } from 'react';

import { Form, Formik } from 'formik';
import { object, string } from 'yup';
import toast, { Toaster } from 'react-hot-toast';

import { Button, Link, Text, Textinput } from '@/atoms';

import { TypeLoginProps } from './types';
import { ButtonVariant } from '../hero/childs/types';
import { LinkVariant } from '@/atoms/link/types';
import { Close } from '@/icons';
import { gtmPush } from '@/utils';
// import SocialMedia from '../social-media';
// import { Close, Facebook, Google, Twitter } from '@/icons';

/**
 * Login
 */
export const Login: FunctionComponent<TypeLoginProps> = ({
  title,
  backgroundColor,
  textButton,
  emailLabel,
  passwordLabel,
  textLinkTop,
  urlLinkTop,
  title2,
  textLinkDown,
  urlLinkDown,
  title3,
  className = '',
}: TypeLoginProps) => {
  const RegisterSchema = object().shape({
    email: string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long')
      .required('El email es Obligatorio'),
    password: string().required('La constraseña es obligatorio'),
  });
  const initialValues: TypeLoginProps = {
    backgroundColor: '',
    title: '',
    textButton: '',
    emailLabel: '',
    passwordLabel: '',
    textLinkTop: '',
    urlLinkTop,
    title2,
    textLinkDown,
    urlLinkDown,
    title3,
    email: '',
    password: '',
  };
  // const socialMedias = [
  //   { Icon: Facebook, href: '#' },
  //   { Icon: Google, href: '#' },
  //   { Icon: Twitter, href: '#' },
  // ];
  /* const error = () =>
    toast('Las contraseña es incorrecta, vuelve a intertarlo por favor.', {
      icon: (
        <Close
          width={64}
          color="#fff"
          className="p-3 rounded-full bg-tertiary-500 font-bold"
        />
      ),
      duration: 2000,
      style: {
        background: '#ffa59c',
        padding: '16px',
        fontWeight: 'bold',
        marginBottom: '80px',
        color: '#fff',
        zIndex: '50',
      },
    }); */
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={`flex flex-col ${className}`}
    >
      <Text className="text-subtitle text-subtitle--l mb-6">{title}</Text>
      <Formik
        onSubmit={async (res) => {
          const response = await fetch('/api/shopify/customer/login', {
            method: 'POST',
            headers: {
              Accept: 'application.json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: res.email,
              password: res.password,
            }),
            cache: 'default',
          });
          const data = await response.json();

          if (data.data.customerAccessTokenCreate.customerAccessToken == null) {
            gtmPush({
              event: 'error',
              evento_asociado: 'login',
              descripcion: 'usuario incorrecto',
            });
            toast('Usuario incorrecto', {
              icon: (
                <Close
                  width={64}
                  color="#fff"
                  className="p-3 rounded-full bg-tertiary-500 font-bold"
                />
              ),
              duration: 2000,
              style: {
                background: '#ffa59c',
                padding: '16px',
                fontWeight: 'bold',
                marginBottom: '80px',
                color: '#fff',
              },
            });
          } else {
            gtmPush({
              event: 'login',
              method: 'email',
              user_id:
                data.data.customerAccessTokenCreate.customerAccessToken
                  .accessToken,
            });
            sessionStorage.setItem(
              'userID',
              data.data.customerAccessTokenCreate.customerAccessToken
                .accessToken
            );
            sessionStorage.setItem('useremail', res.email);
            window.location.href = '/es/cuenta';
          }
        }}
        validationSchema={RegisterSchema}
        initialValues={initialValues}
      >
        <Form noValidate>
          <div className="flex flex-wrap justify-between mb-5">
            <div className="mb-4 w-full">
              <Textinput
                label={emailLabel}
                name="email"
                type="email"
                className="mb-2 w-full md:min-w-[300px]"
                placeholder="ejemplo@gmail.com"
              />
            </div>
            <Textinput
              label={passwordLabel}
              name="password"
              type="password"
              className="mb-2 w-full md:min-w-[300px]"
            />

            <Link href={urlLinkTop} icon="right" variant={LinkVariant.POSITIVE}>
              {textLinkTop}
            </Link>
            <hr className="w-full h-px my-6 text-secondary-200" />
            <div>
              <Text className="text-subtitle text-subtitle--l mb-6">
                {title2}
              </Text>
              <Link
                href={urlLinkDown}
                icon="right"
                variant={LinkVariant.POSITIVE}
              >
                {textLinkDown}
              </Link>
              {/* <hr className="w-full h-px my-6 text-secondary-200" />
              <div>
                <Text className="text-subtitle text-subtitle--m">{title3}</Text>
                <SocialMedia
                  title=""
                  socialMedias={socialMedias}
                  position="start"
                  className="my-6"
                />
              </div> */}
            </div>
          </div>

          <Button variant={ButtonVariant.PRIMARY}>{textButton}</Button>
        </Form>
      </Formik>

      <Toaster
        position="bottom-center"
        containerStyle={{ position: 'absolute' }}
      />
    </div>
  );
};

Login.displayName = 'Login';
